import { IActivityLog } from '~/services/api/activityLogs/types';
import { IFormValues } from '~/ui/components/reusable/ActivityLogOfflineForm/types';

const getInitialValues = ({ note }: IActivityLog): IFormValues => ({
  note,
});

export default getInitialValues;
